import { render, staticRenderFns } from "./change_pw.vue?vue&type=template&id=b71c7214&scoped=true&"
import script from "./change_pw.vue?vue&type=script&lang=js&"
export * from "./change_pw.vue?vue&type=script&lang=js&"
import style0 from "./change_pw.vue?vue&type=style&index=0&id=b71c7214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71c7214",
  null
  
)

export default component.exports